<div class="modal-body">
  <div class="container-fluid" style="width: 100%;height: 100%;">
    <div class="row no-gutters justify-content-end">
      <div
        class="close-button"
        (click)="modalRef.hide()"
        style="font-weight: 600;color:#1384FF; font-size: 25px;cursor: pointer; "
      >
        X
      </div>
    </div>

    <div class="gallery-grid">
      <div id="phone" class="form-group">
        <label for="i-phone">Example Push Notifications</label>
        <div id="i-phone"></div>
      </div>
      <div id="drink">
        <label for="i-drink">Drink Deals</label>
        <div id="i-drink"></div>
      </div>
      <div id="events">
        <label for="i-events">Exclusive Events</label>
        <div id="i-events"></div>
      </div>
      <div id="cover">
        <label for="i-cover">Cashless Cover</label>
        <div id="i-cover"></div>
      </div>
      <div id="lineskip">
        <label for="i-lineskip">Skipping the Line</label>
        <div id="i-lineskip"></div>
      </div>
    </div>
  </div>
</div>
